export default function Biography() {
  return (
    <section id="biography" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-2 relative">
            <div className="absolute -top-4 -left-4 px-4 py-1 border border-amber-600 rounded-full text-xs font-medium text-amber-700 bg-white z-10 whitespace-nowrap">
              ABOUT THE AUTHOR
            </div>
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img 
                src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/8766ce79d993580eb8f66710c4ab0aaa.png" 
                alt="Gary Wilson"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          
          <div className="lg:col-span-3">
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-8 leading-tight">
              Gary<br />Wilson
            </h2>
            <div className="space-y-6 text-gray-600 text-base leading-relaxed">
              <p>
                Gary Wilson is a thoughtful writer and observer of human nature, dedicated to exploring the profound impact of our daily choices. With a background spanning decades of personal and professional experiences, Gary brings a unique perspective to the art of decision-making and its ripple effects throughout our lives.
              </p>
              <p>
                Born and raised in New Jersey, Gary has spent his life surrounded by family and community. His journey as a father to two sons and two daughters, along with his role as a foster parent, has provided him with invaluable insights into the complexities of human relationships and the weight of responsibility that comes with every decision we make.
              </p>
              <p>
                Through his writing, Gary seeks to illuminate the often-overlooked moments that shape our destinies. He believes that even the smallest choices can create waves of consequence, affecting not just ourselves but everyone around us. His debut book reflects years of contemplation, personal growth, and a deep desire to help others navigate life's challenging crossroads with wisdom and intention.
              </p>
              <p>
                When he's not writing, Gary enjoys spending time with his family, reflecting on life's lessons, and engaging with readers who share his passion for meaningful living. His approachable style and genuine warmth have made him a beloved figure among those seeking guidance in their own decision-making journeys.
              </p>
            </div>
            <button className="mt-8 px-8 py-3 bg-gray-900 text-white rounded-lg text-sm font-medium hover:bg-gray-800 transition-colors whitespace-nowrap">
              READ FULL BIOGRAPHY
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}